<template>
  <div class="qr-code-generator">
    <div class="qr-container">
      <div class="qr-code" ref="qrCodeRef"></div>
      <div class="qr-info">
        <h3>{{ $t('meditationQr.scanTitle') }}</h3>
        <p>{{ $t('meditationQr.scanDescription') }}</p>
      </div>
    </div>
    
    <div class="test-button-container">
      <a 
        :href="telegramBotUrl" 
        target="_blank" 
        rel="noopener" 
        class="test-button"
        @click="handleTestClick"
      >
        {{ $t('meditationQr.testButton') }}
      </a>
      <p class="button-description">{{ $t('meditationQr.buttonDescription') }}</p>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { hasAnalyticsConsent } from '../utils/analyticsConsent.js'

export default {
  name: 'QRCodeGenerator',
  data() {
    return {
      telegramBotUrl: 'https://t.me/Renato_achtsamkeit_bot?start=68752fad25aad4692c0de436'
    }
  },
  mounted() {
    this.generateQRCode()
  },
  methods: {
    async generateQRCode() {
      try {
        const canvas = await QRCode.toCanvas(this.telegramBotUrl, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        
        // Clear previous content
        this.$refs.qrCodeRef.innerHTML = ''
        
        // Add the canvas to the DOM
        this.$refs.qrCodeRef.appendChild(canvas)
        
        // Add some styling to the canvas
        canvas.style.borderRadius = '10px'
        canvas.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)'
      } catch (error) {
        console.error('Error generating QR code:', error)
        this.$refs.qrCodeRef.innerHTML = `<p>${this.$t('meditationQr.qrError')}</p>`
      }
    },
    
    handleTestClick() {
      this.firePulsePixelEvent({
        action: 'test',
        type: 'habit_tracker'
      })
    },
    firePulsePixelEvent(payload, attempt = 0) {
      if (!hasAnalyticsConsent()) {
        return
      }

      const spPin = window.SP_PIN
      if (spPin && typeof spPin.fireEvent === 'function') {
        spPin.fireEvent('077437c1-6270-4c88-9cb9-1096d8f75094', payload)
        return
      }

      if (attempt < 10) {
        setTimeout(() => {
          this.firePulsePixelEvent(payload, attempt + 1)
        }, 300)
      }
    }
  }
}
</script>

<style scoped>
.qr-code-generator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 30px;
  background: var(--glass-overlay);
  border-radius: 20px;
  border: 1px solid var(--border-color);
  max-width: 400px;
  margin: 0 auto;
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.qr-code {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.qr-info {
  text-align: center;
}

.qr-info h3 {
  font-size: 1.3rem;
  margin-bottom: 10px;
  color: var(--text-primary);
  background: var(--gradient-green-blue);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.qr-info p {
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}

.test-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.test-button {
  display: inline-block;
  background: var(--glass-overlay);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  color: white;
  padding: 15px 30px;
  border-radius: 25px;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.25s ease;
  box-shadow: 0 8px 24px rgba(217, 70, 239, 0.28);
  border: 1px solid rgba(255,255,255,0.15);
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.test-button:hover {
  transform: translateY(-2px);
  background: rgba(139, 92, 246, 0.25);
  backdrop-filter: blur(25px) saturate(200%);
  -webkit-backdrop-filter: blur(25px) saturate(200%);
  border-color: rgba(255, 255, 255, 0.25);
  box-shadow: 0 12px 28px rgba(217, 70, 239, 0.35);
}

.test-button:active {
  transform: translateY(0);
}

.button-description {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  margin: 0;
  text-align: center;
}

@media (max-width: 768px) {
  .qr-code-generator {
    padding: 20px;
    gap: 25px;
  }
  
  .qr-info h3 {
    font-size: 1.2rem;
  }
  
  .qr-info p {
    font-size: 0.9rem;
  }
  
  .test-button {
    padding: 12px 25px;
    font-size: 1rem;
  }
}
</style>
